'use client';

import { usePageView } from '@/lib/hooks/usePageView';

/**
 * Tiny client component for page view tracking.
 * Extracted to keep parent components as server components for better performance.
 */
export function PageViewTracker() {
  usePageView();
  return null;
}
